import { Role } from '@/api/types'

export default [
    {
        name: 'typeform',
        path: '/typeform',
        redirect: { name: 'typeform_responses' },
        meta: {
            requiredRole: Role.EMPLOYEE,
        },
        component: () => import(/* webpackChunkName: "typeform" */ '../../views/Typeform/Typeform.vue'),
        children: [
            {
                name: 'typeform_responses',
                path: '/typeform/responses',
                meta: {
                    requiredRole: Role.EMPLOYEE,
                },
                component: () => import(/* webpackChunkName: "typeform_responses" */ '../../views/Typeform/Responses/List.vue'),
            },
            {
                name: 'typeform_responses_detail',
                path: '/typeform/responses/:responseId',
                meta: {
                    requiredRole: Role.EMPLOYEE,
                },
                props: true,
                component: () => import(/* webpackChunkName: "typeform_responses_detail" */ '../../views/Typeform/Responses/Detail.vue'),
            },
        ],
    },
]
